import {
	BLUE_TRIANGLE_BTT_REGEX_MAPPING_PT,
	BLUE_TRIANGLE_FALLBACK_PAGE_NAME,
	BLUE_TRIANGLE_HOME_PAGE_NAME,
	BLUE_TRIANGLE_PAGE_TURN_KEY,
	BLUE_TRIANGLE_UT,
} from './constants';
import { BTPageTurn, BttUT, UrlMappingPart } from './types';

export const getBttUT = (): BttUT | null => {
	if (typeof window === 'undefined') return null;
	const bttUT = (window as any)?.[BLUE_TRIANGLE_UT] as BttUT | undefined;
	if (!bttUT || bttUT.rdy !== 1) return null;
	if (typeof bttUT.start !== 'function' || typeof bttUT.end !== 'function') return null;
	return bttUT;
};

export const stripQueryString = (url: string): string => {
	if (!url) return url;
	const qIdx = url.indexOf('?');
	const hIdx = url.indexOf('#');
	const cutPoints = [qIdx, hIdx].filter((i) => i >= 0);
	if (cutPoints.length === 0) return url;
	return url.slice(0, Math.min(...cutPoints));
};

export const retrieveStoreConfMapping = (
	storeConfUserData: Record<string, any>
): UrlMappingPart[] =>
	Object.keys(storeConfUserData)
		.filter((key) => key.startsWith(BLUE_TRIANGLE_BTT_REGEX_MAPPING_PT))
		.sort((a, b) => {
			const numA = parseInt(a.replace(BLUE_TRIANGLE_BTT_REGEX_MAPPING_PT, ''), 10);
			const numB = parseInt(b.replace(BLUE_TRIANGLE_BTT_REGEX_MAPPING_PT, ''), 10);
			return numA - numB;
		})
		.map((key) => {
			try {
				return JSON.parse(storeConfUserData[key]);
			} catch (e) {
				console.error(`${key} has invalid JSON:`, e);
				return null;
			}
		})
		.filter((mapping): mapping is UrlMappingPart => mapping !== null);

export const getPageName = ({
	pathname,
	mappings,
}: {
	pathname: string;
	mappings: UrlMappingPart[];
}): string => {
	if (pathname === '/pro/' || pathname === '' || pathname === '/')
		return BLUE_TRIANGLE_HOME_PAGE_NAME;

	const matchedPage = mappings
		.flatMap((mappingPart) => mappingPart?.urls || [])
		.find(({ url }) => new RegExp(url).test(pathname));

	return matchedPage?.pageName ?? BLUE_TRIANGLE_FALLBACK_PAGE_NAME;
};

export const getVirtualPageName = ({
	pathname,
	mappings,
}: {
	pathname: string;
	mappings: UrlMappingPart[];
}): string => `${getPageName({ pathname, mappings })}-VT`;

export const readBTPageTurn = (): BTPageTurn | null => {
	try {
		if (typeof window === 'undefined') return null;
		const raw = sessionStorage.getItem(BLUE_TRIANGLE_PAGE_TURN_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw) as BTPageTurn;
		if (!parsed?.fromPath || !parsed?.source) return null;
		return parsed;
	} catch (err) {
		console.error('[BT] readBTPageTurn():', err);
		return null;
	}
};

export const writeBTPageTurn = (entry: BTPageTurn): void => {
	try {
		if (typeof window === 'undefined') return;
		sessionStorage.setItem(BLUE_TRIANGLE_PAGE_TURN_KEY, JSON.stringify(entry));
	} catch (err) {
		console.error('[BT] writeBTPageTurn():', err);
	}
};
